import React from 'react'

import { PortalCSRFScript } from '@/shared/api/csrf'
import { BrowserSupportScript } from '@/shared/lib/browser-support'
import { InitWindowDataLayerScript } from '@/shared/lib/data-layer'
import { FacebookSDKScript } from '@/shared/lib/facebook-sdk'
import { GoogleGSIClientScript } from '@/shared/lib/google-login'
import { GoogleTagManagerScript } from '@/shared/lib/google-tag-manager'

export function ScriptsProvider({ children }: React.PropsWithChildren) {
    return (
        <React.Fragment>
            <BrowserSupportScript />
            <PortalCSRFScript />
            <InitWindowDataLayerScript />
            <FacebookSDKScript />
            <GoogleGSIClientScript />
            <GoogleTagManagerScript />

            {children}
        </React.Fragment>
    )
}
